import React from 'react';
import { KeyFactorsGradedImpactDataPoint } from 'apps/sigma2-ui/src/components/key-factors/types';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { guardExhaustive } from 'libs/end-to-end/src/generic';

export interface OptimizingCardTopFactorProps {
  dataPoint: KeyFactorsGradedImpactDataPoint;
}

export const OptimizingCardTopFactor: React.FC<
  OptimizingCardTopFactorProps
> = ({ dataPoint }) => {
  const language = useLanguage();

  const pillBackgroundColor = () => {
    switch (dataPoint.grade) {
      case 'high':
        return '#DFE6F9';
      case 'medium':
        return '#EFE2FD';
      case 'low':
        return '#E7E8E8';
      default:
        throw guardExhaustive(dataPoint.grade);
    }
  };

  const pillTextColor = () => {
    switch (dataPoint.grade) {
      case 'high':
        return 'royal-800';
      case 'medium':
        return 'violet-800';
      case 'low':
        return 'gray-800';
      default:
        throw guardExhaustive(dataPoint.grade);
    }
  };

  return (
    <Box
      as={'div'}
      display={'flex'}
      flex="1"
      justifyContent={'between'}
      alignItems={'center'}
      gap={'sm'}
    >
      <div className="flex-auto">
        <S2Typography
          variant={'body-6-bold'}
          textColorVariant={'royal-900'}
          translatedContent={dataPoint.keyFactorImpactLabel}
        />
      </div>
      <div
        className={`flex-2 bg-[${pillBackgroundColor()}] rounded py-1 px-2 mr-3 w-[100px] whitespace-nowrap text-center`}
      >
        <S2Typography
          variant={'body-7-bold'}
          textColorVariant={pillTextColor()}
          translatedContent={language.keyFactorsOptimizingCardImpact({
            impact: dataPoint.impact,
          })}
        />
      </div>
    </Box>
  );
};
